// ©2024 Austin App House. All rights reserved.
import React, { useMemo } from 'react';
import { MDBBtn } from 'mdbreact';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { exportWorkOrders } from '../../../storage/actions/workOrdersActions';
import prepareFilters from '../../../utils/prepareFilters';
import { getStatus } from '../../../utils/api/get/getWorkOrders';
import DashboardIcon from '../icons/DashboardIcon';

const WorkOrderButtonControl = ({
  history, selectedWorkOrders, openImportModal, userType, exportWorkOrders,
  search, filters, activeTab,
}) => {
  const requestData = useMemo(() => {
    const base = selectedWorkOrders.length
      ? { workOrdersId: selectedWorkOrders }
      : {
        ...search,
        filters: prepareFilters(filters),
      };
    return { ...base, ...getStatus(activeTab) };
  }, [selectedWorkOrders, search, filters, activeTab]);

  const createWorkOrder = (event) => {
    event.preventDefault();
    history.push('/create-work-order');
  };

  return (
    <>
     <div className="action-buttons">
     <button
        className="dashboard-btn dashboard-btn--primary"
        onClick={createWorkOrder}
        aria-label="Create work order"
        type="button"
    >
        <DashboardIcon name="plus" size={18} strokeWidth="2.5" />
        Create work order
    </button>
    <button
        className="dashboard-btn dashboard-btn--secondary"
        onClick={openImportModal}
        aria-label="Import work order(s)"
        type="button"
    >
        <DashboardIcon name="import" size={18} strokeWidth="2" />
        Import work order(s)
    </button>
    <button
        className="dashboard-btn dashboard-btn--secondary"
        onClick={() => exportWorkOrders(requestData, userType)}
        aria-label="Export EXCEL"
        type="button"
    >
        <DashboardIcon name="export" size={18} strokeWidth="2" />
        Export EXCEL
    </button> 
     </div>
      
    </>
  );
};

const mapDispatchToProps = {
  exportWorkOrders,
};

const mapStateToProps = state => ({
  selectedWorkOrders: state.applicationState.selectedWorkOrders,
  activeTab: state.applicationState.activeTab,
  search: state.workOrder.searchData,
  filters: state.workOrder.filters,
});
export default connect(mapStateToProps, mapDispatchToProps)(withRouter(WorkOrderButtonControl));
